import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import { Modal, Button } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import './SuperadminStyles.css';

const UsuariosCliente = () => {
    const history = useHistory();
    const { clienteId } = useParams();
    const [cliente, setCliente] = useState(null);
    const [usuarios, setUsuarios] = useState([]);
    const [filteredUsuarios, setFilteredUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
const [searchTerm, setSearchTerm] = useState('');
    const [estadoFilter, setEstadoFilter] = useState('todos');
    const [rolFilter, setRolFilter] = useState('todos');
    const [currentPage, setCurrentPage] = useState(1);
    const [showEstadoModal, setShowEstadoModal] = useState(false);
    const [showResetModal, setShowResetModal] = useState(false);
    const [usuarioToToggle, setUsuarioToToggle] = useState(null);
    const [usuarioToReset, setUsuarioToReset] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });
    const itemsPerPage = 20;

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        fetchClienteYUsuarios();
    }, [history, clienteId]);

    useEffect(() => {
        // Asegurar que usuarios sea un array antes de filtrar
        if (!Array.isArray(usuarios)) {
            setFilteredUsuarios([]);
            return;
        }

        let filtered = usuarios;

        // Filtrar por estado (campo activo: 1=activo, 0=inactivo)
        if (estadoFilter !== 'todos') {
            const activoValue = estadoFilter === 'activo' ? 1 : 0;
            filtered = filtered.filter(usuario => usuario.activo === activoValue);
        }

        // Filtrar por rol
        if (rolFilter !== 'todos') {
            filtered = filtered.filter(usuario => usuario.rol === rolFilter);
        }

        // Filtrar por búsqueda
        if (searchTerm) {
            filtered = filtered.filter(usuario =>
                (usuario.name && usuario.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (usuario.lastname && usuario.lastname.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (usuario.nombre_completo && usuario.nombre_completo.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (usuario.email && usuario.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (usuario.login && usuario.login.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        }

        setFilteredUsuarios(filtered);
        setCurrentPage(1);
    }, [searchTerm, estadoFilter, rolFilter, usuarios]);

    const fetchClienteYUsuarios = async () => {
        try {
            const [clienteResponse, usuariosResponse] = await Promise.all([
                axios.get(`/superadmin/clientes/${clienteId}`),
                axios.get(`/superadmin/clientes/${clienteId}/usuarios`)
            ]);
            setCliente(clienteResponse.data);
            // Asegurar que siempre sea un array
            const usuariosData = Array.isArray(usuariosResponse.data) ? usuariosResponse.data : [];
            setUsuarios(usuariosData);
            setFilteredUsuarios(usuariosData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('superadmin_token');
                localStorage.removeItem('superadmin_user');
                history.push('/superadmin/login');
            }
            // En caso de error, asegurar que sean arrays vacíos
            setUsuarios([]);
            setFilteredUsuarios([]);
            setLoading(false);
        }
    };

    const handleToggleEstadoClick = (usuario) => {
        setUsuarioToToggle(usuario);
        setShowEstadoModal(true);
    };

    const handleToggleEstadoConfirm = async () => {
        try {
            const nuevoEstado = usuarioToToggle.estado === 1 ? 0 : 1;
            await axios.put(`/superadmin/usuarios/${usuarioToToggle.id}/estado`, {
                estado: nuevoEstado
            });
            setAlert({
                show: true,
                type: 'success',
                message: `Usuario ${nuevoEstado === 1 ? 'activado' : 'desactivado'} exitosamente`
            });
            fetchClienteYUsuarios();
        } catch (error) {
            console.error('Error toggling estado:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al cambiar el estado del usuario'
            });
        } finally {
            setShowEstadoModal(false);
            setUsuarioToToggle(null);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    const handleResetPasswordClick = (usuario) => {
        setUsuarioToReset(usuario);
        setNewPassword('');
        setShowResetModal(true);
    };

    const handleResetPasswordConfirm = async () => {
        try {
            const response = await axios.post(`/superadmin/usuarios/${usuarioToReset.id}/reset-password`);
            setNewPassword(response.data.nueva_password);
            setAlert({
                show: true,
                type: 'success',
                message: 'Contraseña reseteada exitosamente. Guarde la nueva contraseña mostrada.'
            });
        } catch (error) {
            console.error('Error resetting password:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al resetear la contraseña'
            });
            setShowResetModal(false);
            setUsuarioToReset(null);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    const handleCloseResetModal = () => {
        setShowResetModal(false);
        setUsuarioToReset(null);
        setNewPassword('');
    };

    const limiteAlcanzado = cliente && usuarios.length >= cliente.limite_usuarios;

    // Paginación - asegurar que filteredUsuarios sea un array
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = Array.isArray(filteredUsuarios) ? filteredUsuarios.slice(indexOfFirstItem, indexOfLastItem) : [];
    const totalPages = Array.isArray(filteredUsuarios) ? Math.ceil(filteredUsuarios.length / itemsPerPage) : 0;

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <SuperadminLayout>
                            {/* Header con info del cliente */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h4><i className="fas fa-users"></i> Usuarios de {cliente?.nombre}</h4>
                                        <p className="text-muted mb-0">
                                            NIT: {cliente?.nit} | Email: {cliente?.email_contacto}
                                        </p>
                                    </div>
                                    <Link to="/superadmin/clientes" className="btn btn-secondary">
                                        <i className="fas fa-arrow-left"></i> Volver a Clientes
                                    </Link>
                                </div>
                                
                                <div className="alert alert-info">
                                    <strong>
                                        <i className="fas fa-info-circle"></i> {usuarios.length} de {cliente?.limite_usuarios} usuarios utilizados
                                    </strong>
                                    {limiteAlcanzado && (
                                        <span className="text-danger ml-3">
                                            <i className="fas fa-exclamation-triangle"></i> Límite alcanzado
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5>Listado de Usuarios</h5>
                                <Link
                                    to={`/superadmin/clientes/${clienteId}/usuarios/nuevo`}
                                    className={`btn btn-superadmin ${limiteAlcanzado ? 'disabled' : ''}`}
                                    onClick={(e) => limiteAlcanzado && e.preventDefault()}
                                    title={limiteAlcanzado ? 'Límite de usuarios alcanzado' : 'Crear nuevo usuario'}
                                >
                                    <i className="fas fa-plus"></i> Crear Usuario
                                </Link>
                            </div>

                            {/* Alertas */}
                            {alert.show && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ show: false, type: '', message: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            {/* Filtros */}
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar por nombre o email..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <select
                                        className="form-control"
                                        value={estadoFilter}
                                        onChange={(e) => setEstadoFilter(e.target.value)}
                                    >
                                        <option value="todos">Todos los estados</option>
                                        <option value="activo">Activos</option>
                                        <option value="inactivo">Inactivos</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <select
                                        className="form-control"
                                        value={rolFilter}
                                        onChange={(e) => setRolFilter(e.target.value)}
                                    >
                                        <option value="todos">Todos los roles</option>
                                        <option value="admin">Admin</option>
                                        <option value="doctor">Doctor</option>
                                        <option value="asistente">Asistente</option>
                                    </select>
                                </div>
                            </div>

                            {/* Tabla */}
                            <div className="table-responsive">
                                <table className="table table-hover superadmin-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nombre</th>
                                            <th>Email</th>
                                            <th>Login</th>
                                            <th>Estado</th>
                                            <th>Último Acceso</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length > 0 ? (
                                            currentItems.map(usuario => (
                                                <tr key={usuario.id}>
                                                    <td>{usuario.id}</td>
                                                    <td>{usuario.nombre_completo || `${usuario.name} ${usuario.lastname}`}</td>
                                                    <td>{usuario.email}</td>
                                                    <td>{usuario.login || '-'}</td>
                                                    <td>
                                                        <span className={`badge badge-${usuario.activo === 1 ? 'success' : 'secondary'}`}>
                                                            {usuario.activo === 1 ? 'Activo' : 'Inactivo'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {usuario.updated_at ? 
                                                            new Date(usuario.updated_at).toLocaleDateString() : 
                                                            <span className="text-muted">Nunca</span>
                                                        }
                                                    </td>
                                                    <td>
                                                        <Link
                                                            to={`/superadmin/usuarios/editar/${usuario.id}`}
                                                            className="btn btn-sm btn-dark mr-1"
                                                            title="Editar"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </Link>
                                                        <button
                                                            className="btn btn-sm btn-warning mr-1"
                                                            onClick={() => handleResetPasswordClick(usuario)}
                                                            title="Resetear contraseña"
                                                        >
                                                            <i className="fas fa-key"></i>
                                                        </button>
                                                        <button
                                                            className={`btn btn-sm btn-${usuario.estado === 1 ? 'danger' : 'success'}`}
                                                            onClick={() => handleToggleEstadoClick(usuario)}
                                                            title={usuario.estado === 1 ? 'Desactivar' : 'Activar'}
                                                        >
                                                            <i className={`fas fa-${usuario.estado === 1 ? 'ban' : 'check'}`}></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    No se encontraron usuarios
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Paginación */}
                            {totalPages > 1 && (
                                <nav>
                                    <ul className="pagination justify-content-center">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Anterior
                                            </button>
                                        </li>
                                        {[...Array(totalPages)].map((_, index) => (
                                            <li
                                                key={index + 1}
                                                className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Siguiente
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
            {/* Modal de Confirmación Estado */}
            <Modal show={showEstadoModal} onHide={() => setShowEstadoModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Cambio de Estado</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro que desea {usuarioToToggle?.estado === 1 ? 'desactivar' : 'activar'} al usuario{' '}
                    <strong>{usuarioToToggle?.nombre} {usuarioToToggle?.apellido}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEstadoModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant={usuarioToToggle?.estado === 1 ? 'danger' : 'success'}
                        onClick={handleToggleEstadoConfirm}
                    >
                        {usuarioToToggle?.estado === 1 ? 'Desactivar' : 'Activar'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Reset Password */}
            <Modal show={showResetModal} onHide={handleCloseResetModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Resetear Contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!newPassword ? (
                        <>
                            ¿Está seguro que desea resetear la contraseña del usuario{' '}
                            <strong>{usuarioToReset?.nombre} {usuarioToReset?.apellido}</strong>?
                            <br /><br />
                            <small className="text-muted">
                                Se generará una nueva contraseña temporal que deberá entregar al usuario.
                            </small>
                        </>
                    ) : (
                        <div className="alert alert-success">
                            <h6>Nueva contraseña generada:</h6>
                            <h4 className="text-center my-3">
                                <code>{newPassword}</code>
                            </h4>
                            <small className="text-danger">
                                <i className="fas fa-exclamation-triangle"></i> Guarde esta contraseña. No se volverá a mostrar.
                            </small>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!newPassword ? (
                        <>
                            <Button variant="secondary" onClick={handleCloseResetModal}>
                                Cancelar
                            </Button>
                            <Button variant="warning" onClick={handleResetPasswordConfirm}>
                                Resetear Contraseña
                            </Button>
                        </>
                    ) : (
                        <Button variant="dark" onClick={handleCloseResetModal}>
                            Cerrar
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </SuperadminLayout>
    );
};

export default UsuariosCliente;
